<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button @click="cancel()">
          <ion-icon :icon="closeOutline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title >{{ review?.title }}</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <div class="content">
      <p>“{{ review?.description }}”</p>
      <ion-row>
        <ion-col class="username" @click="$router.push(`/profile/${review?.user.id}`); cancel()">{{ username }}</ion-col>
        <ion-col class="ion-text-end rating">
          <ion-icon
            :icon="star"
            v-for="n in Math.round(parseFloat(review?.rating))"
            class="yellow-star"
            :key="n"
          />
          <ion-icon
            :icon="starOutline"
            v-for="n in Math.round(5 - parseFloat(review?.rating))"
            class="black-star"
            :key="n"
          />
          ({{ review?.rating }})
        </ion-col>
      </ion-row>
      <ion-row class="ion-justify-content-end date">{{ date }}</ion-row>
    </div>
  </ion-content>
</template>
<script setup lang="ts">
import { computed, defineProps } from "vue";
import {
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonIcon,
  IonTitle,
  IonContent,
  IonRow,
  IonCol,
  modalController,
} from "@ionic/vue";
import { closeOutline, star, starOutline } from "ionicons/icons";
const props = defineProps({ review: Object });
const username = computed(
  () => `${props.review?.user?.profile.nickName}`
);
const date = computed(() =>
  new Date(props.review?.updatedAt).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  })
);
const cancel = () => modalController.dismiss(false, "cancel");
</script>
<style lang="scss" scoped>
@import "../../theme/variables/_color.scss";
@import "../../theme/variables/_typography.scss";
ion-modal {


  & ion-content {
    & .content {
      padding: 20px 20px 40px;
      & p {
        padding-bottom: 20px;
        @include text-14-normal;
        line-height: 26px;
        color: rgba(34, 34, 34, 0.78);
      }

      & .username {
        @include text-16-bold;
        color: #222;
      }

      & .rating {
        @include text-10-normal;
        color: #22222260;
        & ion-icon {
          &.yellow-star {
            color: #fbbc05;
          }
          &.black-star {
            color: #222;
          }
        }
      }
      & .date {
        @include text-10-bold;
        line-height: 26px;
        color: #222;
        opacity: 0.5;
      }
    }
  }
}
.review-title {
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  text-transform: capitalize;
}
</style>
